var _rect, _rect2, _rect3, _rect4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmsSkeleton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 218,
    height: 115,
    viewBox: "0 0 218 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 203,
    height: 13,
    rx: 6.5,
    fill: "#D6D6D6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 34,
    width: 164,
    height: 13,
    rx: 6.5,
    fill: "#D6D6D6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 68,
    width: 181,
    height: 13,
    rx: 6.5,
    fill: "#D6D6D6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 102,
    width: 218,
    height: 13,
    rx: 6.5,
    fill: "#D6D6D6"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmsSkeleton);
export default __webpack_public_path__ + "static/media/sms-skeleton.48910f1a7a368917bb1812ee7b9a05fa.svg";
export { ForwardRef as ReactComponent };